export default "__VITE_ASSET__f1a4e942__"